import { useCallback, useMemo } from 'react';
import ChartOptions from '../../../../../components/Charts/Options';

import { Scale } from '../../../../../types/Chart';
import { CandleType, TimeFrame } from '../../../../Detail/types';

import './index.css';

interface Props {
  scale: Scale;
  setScale: (scale: Scale) => void;
  candleType: CandleType;
  setCandleType: (candleType: CandleType) => void;
  timeFrame: TimeFrame;
  setTimeFrame: (timeFrame: TimeFrame) => void;
  setShouldFetch: React.Dispatch<React.SetStateAction<boolean>>;
}

const CandlesChartOptions = (props: Props) => {
  const {
    scale,
    setScale,
    candleType,
    setCandleType,
    timeFrame: selectedTimeFrame,
    setTimeFrame,
    setShouldFetch,
  } = props;

  const setLinear = useCallback(() => {
    setScale(Scale.Linear);
  }, [setScale]);

  const setLog = useCallback(() => {
    setScale(Scale.Log);
  }, [setScale]);

  const setNormalCanleType = useCallback(() => {
    setCandleType(CandleType.Normal);
  }, [setCandleType]);

  const setHeikinCanleType = useCallback(() => {
    setCandleType(CandleType.Heikin);
  }, [setCandleType]);

  const handleTimeFrameChange = (timeFrame: TimeFrame) => {
    setTimeFrame(timeFrame);
    setShouldFetch(true);
  };

  const timeFrames = useMemo(() => Object.values(TimeFrame), []);

  return (
    <div className="candles-content-options">
      <ChartOptions>
        <ChartOptions.OptionsWrapper>
          <ChartOptions.Option
            label="LINEAR"
            isSelected={scale === Scale.Linear}
            handleSelect={setLinear}
          />
          <ChartOptions.Option
            label="LOG"
            isSelected={scale === Scale.Log}
            handleSelect={setLog}
          />
        </ChartOptions.OptionsWrapper>
        <ChartOptions.OptionsWrapper>
          <ChartOptions.Option
            label="NORMAL"
            isSelected={candleType === CandleType.Normal}
            handleSelect={setNormalCanleType}
          />
          <ChartOptions.Option
            label="HEIKIN"
            isSelected={candleType === CandleType.Heikin}
            handleSelect={setHeikinCanleType}
          />
        </ChartOptions.OptionsWrapper>
        <ChartOptions.OptionsWrapper scroll>
          {timeFrames.map((timeFrame) => (
            <ChartOptions.Option
              key={timeFrame}
              label={timeFrame}
              isSelected={timeFrame === selectedTimeFrame}
              handleSelect={() => handleTimeFrameChange(timeFrame)}
            />
          ))}
        </ChartOptions.OptionsWrapper>
      </ChartOptions>
    </div>
  );
};

export default CandlesChartOptions;
